import React from "react"

import DineroFactory from "dinero.js"

import {
  CartItemContainer,
  InfoWrapper,
  ItemDetails,
  ItemImage,
  ItemName,
  ItemPrice,
  SalePrice
} from "./CartItem.styled"
import Money from "../../../../../Money"
import { OrderLine } from "lib/types/generated/graphql-types"
import { Id } from "../../Shared.styled"
import { handleImageError } from "helpers/image"

type Props = {
  item: OrderLine
  currencyCode?: string
  refetch: () => void
}

const CartItem = ({ item, currencyCode, ...props }: Props) => {

  return (
    <CartItemContainer {...props}>
      <InfoWrapper>
        <ItemImage>
          <img src={item?.imageUrl ?? ""} onError={handleImageError} />
        </ItemImage>
        <ItemDetails>
          <ItemName>{item?.name}</ItemName>
          <Id>
            <b>Variant ID: </b>
            {item.productVariantId}
          </Id>
          <ItemPrice>
            <SalePrice>
              <div>
                Price:
                 ({item.quantity} *{" "}
                <Money
                  amount={Number(item?.basePriceAmount)}
                  currencyUnit={currencyCode as DineroFactory.Currency}
                />)
              </div>
              <Money
                amount={Number(item?.basePriceAmount * item.quantity)}
                currencyUnit={currencyCode as DineroFactory.Currency}
              />
            </SalePrice>
          </ItemPrice>
          <SalePrice>
            <div>
              Discount:
            </div>
            -
              <Money
                amount={item.distributedTotalDiscountAmount}
                currencyUnit={currencyCode as DineroFactory.Currency}
              />

          </SalePrice>
          <SalePrice>
            <div>Total:{" "}</div>
            <Money
              amount={item.distributedTotalPriceAmount}
              currencyUnit={currencyCode as DineroFactory.Currency}
            />
          </SalePrice>
        </ItemDetails>
      </InfoWrapper>
    </CartItemContainer>
  )
}

export default CartItem
